import React from 'react'
import Header from '../Header/Header'
import NumerosData from '../../Components/Admin/NumerosData/NumerosData'
import HeaderDash from '../../Components/Admin/HeaderDash/HeaderDash'

export default function Numeros() {
    return (
        <div className='containerGrid'>
            <Header />

            <section className='containerSection'>

                <HeaderDash />
                <div className='container'>
                    <NumerosData />

                </div>
            </section>
        </div>
    )
}

